import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import style from './Nodes.style';
import {
    FMCheckbox,
    FMTreeNode,
    FMTreeItemNodeWithStore
} from 'atoms';
import { ItemProps } from '../../organisms/FMTree/TypesForNodes';

class FMTreeItemNode extends React.Component<ItemProps> {

    public render() {
        return (
            <FMTreeNode
                level={this.props.level}
                selected={this.props.selected}
            >
                <FMCheckbox
                    checked={this.props.checked}
                    onClick={this.props.checked ? this.props.uncheckNode : this.props.checkNode}
                />
                <div className={this.props.classes.nodeName} onClick={this.props.selectNode}>
                    {this.props.name}
                </div>
            </FMTreeNode>
        );
    }

}

export default withStyles(style)(FMTreeItemNodeWithStore(FMTreeItemNode));
